import { useFeatureFlagEnabled } from 'posthog-js/react'

/**
 * PostHog flag gating the two State identity providers, ProConnect and FranceConnect.
 *
 * Both are pending official validation (ProConnect partner registration, FranceConnect DINUM
 * authorization), so until then nothing about them may appear outside the team: no button, no
 * "recognized public-sector address" notice, no admin section, not even a "coming soon" badge.
 *
 * Rolled out on the email DOMAIN — `@communo.app` — which is why it also works on the login
 * screen: that page runs before authentication, and it feeds only the typed domain to PostHog
 * (see PostHogService.setEmailDomainForFlags).
 */
export const STATE_SSO_FEATURE_FLAG = 'sso-proconnect-franceconnect'

/**
 * Whether the ProConnect / FranceConnect features may be shown at all.
 *
 * Defaults to FALSE, and deliberately so: `useFeatureFlagEnabled` returns `undefined` while
 * flags are still loading and whenever PostHog is not configured (local dev, CI, an ad
 * blocker). Treating those as "off" means an unvalidated integration can never flash on screen
 * because analytics happened to be slow or absent — the failure mode is hiding the feature, not
 * leaking it.
 */
export function useStateSsoFeature(): boolean {
  return useFeatureFlagEnabled(STATE_SSO_FEATURE_FLAG) === true
}
